// Module
var code = "<div id=\"V-AE3A51A4-B191-4D46-A909-BB85E8AFC888\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\" data-b-comp-allowsuggestion=\"true\" data-b-comp-suggestionsseparator=\"&nbsp\" data-b-comp-suggestions=\"{Binding suggestions}\"></div> </div> ";
// Exports
export default code;